// Function to parse a value to boolean
export const parseBoolean = (value) => {
  if (value) {
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return Boolean(value);
  } else {
    return null;
  }
};

// Function to convert a file to a data URL
export const fileToDataUrl = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  });
};

// Parse phone numbers from textarea
export const parsePhoneNumbersFromStrings = (text) => {
  if (!text) return [];
  return text?.split(/[\n,،]+/)?.map((num) => num.trim())?.filter((num) => num.length > 0);
};